import { AlignmentType, HeadingLevel, Paragraph, TextRun } from "docx";
import { drawBasicTable } from "../../write-sections/write_utils/drawTables_examples.js";
import { renderToStringAlt } from "../../../create-report/shared-components/renderToString.js";

const headers = [
    "Gene symbol",
    "Transcript (RefSeq)",
    "Mean coverage",
    "Median coverage",
    "C1",
    "C10",
    "C15",
    "C20",
];

const dataKeys = [
    "gene_symbol",
    "transcript",
    "mean_coverage",
    "median_coverage",
    "c1",
    "c10",
    "c15",
    "c20"
];

function WriteGenesInterestSection(sectionData) {
    let rows = sectionData && Array.isArray(sectionData) ? sectionData : [];
    
    return [
        new Paragraph({
            children: [
                new TextRun({
                    text: renderToStringAlt("Coverage of the genes of interest (RefSeq coding regions)"),
                    bold: true,
                    size: 22 
                })
            ],
        }),

        new Paragraph({
            text: "",
        }),
        new Paragraph({
            text: renderToStringAlt("All genes have a C10 of 90 or more, except for:"),
        }),
        new Paragraph({
            text: "",
        }),
        drawBasicTable(rows, headers, dataKeys, renderToStringAlt("No data available")),
    ];
}

export default WriteGenesInterestSection;



